import { feathers } from '@feathersjs/feathers';
import socketio from '@feathersjs/socketio-client';
// @ts-ignore
import io from 'socket.io-client';

const socketIO = io(import.meta.env.VITE_API_URL || 'http://127.0.0.1:3030');
const socket = feathers();

socket.configure(socketio(socketIO));

socketIO.on('connect', () => {
  console.info('Socket connected');
});

export default socket;
